import MasterStockList from "pages/report/master-stock/list"
import useMasterStockValueGlobalReportRepositories from "repositories/master-stock-value-global-report"

export default function List() {
  return (
    <MasterStockList
      title="Nilai Stock Barang Global"
      description="Ringkasan nilai stock barang per group atau product model pada tanggal yang dipilih."
      labelHeader="GROUP"
      endpoint="/reports/master-stock-value-global"
      useRepository={useMasterStockValueGlobalReportRepositories}
    />
  )
}
